import { isNewListing } from "@shared/property-context";

/**
 * "New Listing!" wherever a home is named or pictured, for the home that just
 * joined the site. Reads from one place (isNewListing) so the badge appears
 * and retires everywhere at once.
 */
export function NewListingBadge({
  slug,
  variant = "inline",
  className = "",
}: {
  slug: string | null | undefined;
  /** overlay: pinned to a photo's corner. inline: beside a title or name. */
  variant?: "overlay" | "inline";
  className?: string;
}) {
  if (!isNewListing(slug)) return null;
  // [-webkit-text-fill-color:currentColor] is not decoration: dropped inside
  // gradient-clipped text, such as the hero eyebrow, the inherited
  // transparent fill colour left a green pill with no words in it.
  const base = "inline-flex items-center rounded-full bg-sun px-3 py-1 font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-shell [-webkit-text-fill-color:currentColor] shadow-[0_2px_8px_rgba(0,0,0,0.18)]";
  const place = variant === "overlay" ? "absolute left-3 top-3 z-10" : "align-middle";
  return (
    <span className={`${base} ${place} ${className}`} data-testid={`new-listing-${slug}`}>
      New Listing!
    </span>
  );
}
